module.exports = __webpack_public_path__ + "static/img/banner1.3788b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1.png
// module id = 1MxG
// module chunks = 13